// @core/api/endpoints/document/list_numbering_schemes.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListNumberingSchemesResponse,
} from '../../../types/document';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/document';

/**
 * List numbering schemes
 * Returns available numbering schemes, optionally filtered by document type.
 */
export async function ListNumberingSchemes(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListNumberingSchemesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/numbering-schemes`;
  const requestOptions = options;
  return client.get<ListNumberingSchemesResponse>(requestPath, { ...requestOptions, params });
}
